import React from 'react';
import { Pill } from '@andes/badge';
import { Icon } from '@vpp-frontend-components/icon';
import { vehicleReservationDataShape } from './prop-types';

const namespace = 'vehicle-reservation-with-credit';

const VehicleReservationPill = ({ data }) => {
  const showPill = data?.id === 'vehicle_reservation_approved_credit_pill' && data?.state === 'VISIBLE';

  if (!showPill) {
    return null;
  }
  const { action } = data;
  const { label } = action || {};

  return (
    <div className={`${namespace}__pill-container`}>
      <Pill
        className={`${namespace}__pill`}
        color={label?.bg_color?.toLowerCase()}
        size={label?.font_size?.toLowerCase()}
      >
        {label?.text_icon?.id === 'MELICHOICE_LOGO' && <Icon id="MELICHOICE_LOGO" className={`${namespace}__icon`} />}
        {label?.text}
      </Pill>
    </div>
  );
};

VehicleReservationPill.propTypes = {
  data: vehicleReservationDataShape,
};

export default VehicleReservationPill;
